<template>
  <b-switch v-model="value.data" />
</template>

<script>
export default {
  name: 'c-switch',
  props: ['value'],
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/lib/components/Switch.vue